import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const API = axios.create({
  baseURL: BASE_URL,
});

API.interceptors.request.use((config) => {
  try {
    const authData = JSON.parse(localStorage.getItem('sdny_auth_v1') || '{}');
    if (authData?.token) {
      config.headers['Authorization'] = `Bearer ${authData.token}`;
    }
    if (authData?.user?.id) {
      config.headers['X-User-ID'] = String(authData.user.id);
    }
  } catch {}
  return config;
});

export const ENDPOINTS = {
  cart: '/cart',
  cartItem: (id) => `/cart/${id}`,
  auth: {
    login: '/auth/login',
    register: '/auth/register',
  },
  orders: '/orders',
  order: (id) => `/orders/${id}`,
};
